
import React, { Component } from 'react';
import { Row,Col, Button, FormGroup, Label, Input } from 'reactstrap';
import { connect } from "react-redux";
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';
import Conversions from '../../../../../Resources/Conversions';
import { addHoursPeriodModal } from '../../../../../action/modalStateAction';



class AddHoursPeriod extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.AddhoursPeriod = this.AddhoursPeriod.bind(this);
         this.cancelFunction = this.cancelFunction.bind(this);
      }

      componentDidMount(){
        var disabled_States =this.props.disabled_States;
        if(disabled_States != null){
            var checkboxes = document.getElementsByClassName("Days_checkbox");
            /* eslint-disable */
            for (var i=0; i < 7; i++){
                checkboxes[i].checked = false;
                checkboxes[i].disabled = true;
            }
            for (var i = 0; i < disabled_States.length; i++ ) {
                  checkboxes[disabled_States[i]].checked = true;
                  checkboxes[disabled_States[i]].disabled = false;  
            }
        }
      }
    
      AddhoursPeriod(){
          //Start time value
        var s_h = document.getElementById("start_hours");  var s_hours = s_h.options[s_h.selectedIndex].value;
        var s_m = document.getElementById("start_minutes");  var s_minutes = s_m.options[s_m.selectedIndex].value;
        var s_ampm = document.getElementById("start_period");   var s_am_pm = s_ampm.options[s_ampm.selectedIndex].value;

        var starttime = s_hours+":"+s_minutes+" "+s_am_pm ;

        //End time value
        var e_h = document.getElementById("end_hours"); var e_hours = e_h.options[e_h.selectedIndex].value;
        var e_m = document.getElementById("end_minutes");  var e_minutes = e_m.options[e_m.selectedIndex].value;  
        var e_ampm = document.getElementById("end_period"); var e_am_pm = e_ampm.options[e_ampm.selectedIndex].value;

        var endtime = e_hours+":"+e_minutes+" "+e_am_pm ;
       
        var hours_period = [Conversions.convertTo24Hour(starttime),Conversions.convertTo24Hour(endtime)];


       var selected_days = [];
      var checkboxes = document.getElementsByClassName("Days_checkbox");
      for (var i = 0; i < checkboxes.length; i++ ) {
         if(checkboxes[i].checked === true) {
           var id = checkboxes[i].id;
           selected_days.push(id);
         }
      }
      var add_hours_period_Data={"hours_period":hours_period,"selected_days":selected_days}
     this.props.addHoursPeriodModal(add_hours_period_Data);
     this.cancelFunction(add_hours_period_Data);
     
    }

    

    cancelFunction(data){
        this.props.someFunctionHere(data);
      }


    render() {
       

        return (
            <div className="AddHoursPeriod_Modal">
                <h4 className="Modal_form_title">Add Normal Hours Periods</h4>

        <FormGroup>
          <Label for="exampleSelect">Start &nbsp;</Label>
            <select  id="start_hours" className="hours_select">
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option>5</option>
            <option>6</option>
            <option>7</option>
            <option selected="selected">8</option>
            <option>9</option>
            <option>10</option>
            <option>11</option>
            <option>12</option>
           </select>  &nbsp;

            <select  id="start_minutes" className="Select_input">
            <option>00</option>
            <option>15</option>
            <option>30</option>
            <option>45</option>
           </select>  &nbsp;

            <select  id="start_period" className="Select_input">
            <option>AM</option>
            <option>PM</option>
           </select>
        </FormGroup>


         <FormGroup>
          <Label for="exampleSelect">End  &nbsp;</Label>
            <select  id="end_hours" className="hours_select">
            <option>1</option>
            <option>2</option>
            <option>3</option>
            <option>4</option>
            <option selected="selected">5</option>
            <option>6</option>
            <option>7</option>
            <option>8</option>
            <option>9</option>
            <option>10</option>
            <option>11</option>
            <option>12</option>
           </select> &nbsp;

            <select  id="end_minutes" className="Select_input">
            <option>00</option>
            <option>15</option>
            <option>30</option>
            <option>45</option>
           </select>  &nbsp;

            <select  id="end_period" className="Select_input">
            <option>AM</option>
            <option selected="selected">PM</option>
           </select>
        </FormGroup>

                <p  className=""><b>Add this period to the following days</b></p> 
                <Row >
                <Col sm={{ size: 8}} >
                <Row >
                
                    <Col sm={{ size: 2}} >
                    <FormGroup check className="Day_checkbox">
                        <Label check> <Input type="checkbox" id="0"  className="Days_checkbox" style={{margin: (this.props.OnPremises) ? "0px 0px 0px -16px": {}}}/>{'  '} Sunday</Label>
                    </FormGroup>
                    </Col>

                    <Col sm={{ size: 2}} >
                     <FormGroup check>
                        <Label check> <Input type="checkbox" id="1" className="Days_checkbox" style={{margin: (this.props.OnPremises) ?  "0px 0px 0px -17px": {}}}/>{'  '} Monday</Label>
                    </FormGroup>
                    </Col>

                    <Col sm={{ size: 2}} >
                    <FormGroup check>
                        <Label check> <Input type="checkbox" id="2" className="Days_checkbox" style={{margin: (this.props.OnPremises) ?  "0px 0px 0px -16px": {}}}/>{'  '} Tuesday &nbsp;</Label>
                    </FormGroup>
                    </Col>


                    <Col sm={{ size: 2}} >
                    <FormGroup check>
                        <Label check> <Input type="checkbox" id="3" className="Days_checkbox" style={{margin: (this.props.OnPremises) ?  "0px 0px 0px -17px": {}}}/>{'  '} Wednesday</Label>
                    </FormGroup>

                    </Col>
                </Row >
                    
                    </Col>
                </Row >



<Row >
                <Col sm={{ size: 8}} >
                <Row >
                
                    <Col sm={{ size: 2}} >
                    <FormGroup check>
                        <Label check> <Input type="checkbox" id="4" className="Days_checkbox" style={{margin: (this.props.OnPremises) ?  "0px 0px 0px -16px": {}}}/>{'  '} Thursday</Label>
                    </FormGroup>
                    </Col>

                    <Col sm={{ size: 2}} >
                    <FormGroup check>
                        <Label check> <Input type="checkbox" id="5" className="Days_checkbox" style={{margin: (this.props.OnPremises) ? "0px 0px 0px -17px": {}}}/>{'  '} Friday</Label>
                    </FormGroup>
                    </Col>

                    <Col sm={{ size: 2}} >
                    <FormGroup check>
                        <Label check> <Input type="checkbox" id="6" className="Days_checkbox" style={{margin: (this.props.OnPremises) ?  "0px 0px 0px -16px": {}}}/>{'  '} Saturday</Label>
                    </FormGroup>
                    </Col>
                  
                </Row >
                    
                    </Col>
                </Row > <br/>
                
                   
                    <FormGroup row >
                        <Col sm={{ size: 12 }}>
                            <Button className="btn-gray" onClick={this.cancelFunction}  > Cancel </Button>
                            <Button className="btn-success"  onClick={ this.AddhoursPeriod } > Done </Button>
                        </Col>
                    </FormGroup>
            </div>
        );
    }
}

const mapStateToProps = state =>{
    return{
        OnPremises: state.authService.IsOnPremise
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addHoursPeriodModal: (data) => dispatch(addHoursPeriodModal(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddHoursPeriod);
            